import { render, staticRenderFns } from "./TwitterPoll.vue?vue&type=template&id=c705979e"
import script from "./TwitterPoll.vue?vue&type=script&lang=js"
export * from "./TwitterPoll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports